import moment from 'moment'
import React, { Component, Fragment } from 'react'
import { Card, Col, Form, Icon, Input, Row, Tooltip } from 'antd'
import TagSelect from '../../../../../elements/Select/Tag'
import CountrySelect from '../../../../../elements/Select/Country'

const FormItem = Form.Item

function AddressList(props) {
  const {
    list = [
      {
        category: 'address',
        default: true,
        _key: moment().unix(),
        new: true,
      },
    ],
    handleChange,
    getFieldDecorator,
    formItemLayout,
    handleDefault,
    handleRemove,
    handleAdd,
    fetching,
  } = props
  let counter = 0
  console.log(123, { list })

  return (
    <Card loading={fetching} title="Address" type={'inner'} bordered={false} {...formItemLayout}>
      {list.filter((f) => f.remove !== true).length < 1 && (
        <Icon
          type={'plus-circle'}
          onClick={handleAdd.bind(this, 'address')}
          style={{ fontSize: '13pt', cursor: 'pointer' }}
        />
      )}
      {list
        .filter((f) => f.remove !== true)
        .map((e) => {
          counter++
          return (
            <Fragment>
              <Row
                style={{
                  borderBottom: 'solid 2px #108ee9',
                  paddingBottom: 10,
                  marginBottom: 10,
                }}>
                <FormItem label="Tag" {...formItemLayout} style={{ paddingTop: 10 }}>
                  <Col span={12}>
                    <FormItem {...formItemLayout}>
                      <TagSelect onChange={handleChange.bind(this, 'address', e._key, 'tag')} value={e.tag} />
                    </FormItem>
                  </Col>
                  <Col span={2}>
                    <FormItem {...formItemLayout}>
                      <Tooltip title={'Set as Default'}>
                        <Icon
                          type={'star'}
                          theme={e.default && 'filled'}
                          style={{
                            fontSize: '13pt',
                            color: '#ceb21b',
                            cursor: 'pointer',
                          }}
                          onClick={!e.default && handleDefault.bind(this, 'address', e._key)}
                        />
                      </Tooltip>
                    </FormItem>
                  </Col>
                  <Col span={1}>
                    <FormItem {...formItemLayout}>
                      <Icon
                        type={'minus-circle'}
                        onClick={handleRemove.bind(this, 'address', e._key)}
                        style={{ fontSize: '13pt', cursor: 'pointer' }}
                      />
                    </FormItem>
                  </Col>
                  <Col span={1}>
                    <FormItem>
                      {counter === list.filter((f) => f.remove !== true).length && (
                        <Icon
                          type={'plus-circle'}
                          onClick={handleAdd.bind(this, 'address')}
                          style={{ fontSize: '13pt', cursor: 'pointer' }}
                        />
                      )}
                    </FormItem>
                  </Col>
                </FormItem>

                <FormItem label="Address" {...formItemLayout}>
                  <Col span={12}>
                    <FormItem {...formItemLayout}>
                      <Input
                        placeholder="Building"
                        onChange={handleChange.bind(this, 'address', e._key, 'address')}
                        value={e.address}
                      />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem {...formItemLayout}>
                      {getFieldDecorator('street' + e._key, {
                        initialValue: e.street,
                        rules: [
                          {
                            required: true,
                            message: 'Address 1 is required',
                          },
                        ],
                      })(
                        <Input
                          placeholder="Street"
                          onChange={handleChange.bind(this, 'address', e._key, 'street')}
                          value={e.street}
                        />
                      )}
                    </FormItem>
                  </Col>
                </FormItem>

                <FormItem label=" " {...formItemLayout}>
                  <Col span={12} style={{ borderBottom: 'solid 2px color:#49a9ee' }}>
                    <FormItem {...formItemLayout}>
                      <Input
                        placeholder="Town / Suburb"
                        onChange={handleChange.bind(this, 'address', e._key, 'city')}
                        value={e.city}
                      />
                    </FormItem>
                  </Col>
                  <Col span={12} style={{ borderBottom: 'solid 2px color:#49a9ee' }}>
                    <FormItem {...formItemLayout}>
                      <Input
                        placeholder="City State"
                        onChange={handleChange.bind(this, 'address', e._key, 'state')}
                        value={e.state}
                      />
                    </FormItem>
                  </Col>
                </FormItem>
                <FormItem label=" " {...formItemLayout}>
                  <Col span={12}>
                    <FormItem {...formItemLayout}>
                      <Input
                        placeholder="Postcode"
                        onChange={handleChange.bind(this, 'address', e._key, 'postcode')}
                        value={e.postcode}
                      />
                    </FormItem>
                  </Col>
                </FormItem>
                <FormItem label="Country" {...formItemLayout}>
                  <Col span={12}>
                    <FormItem {...formItemLayout}>
                      {getFieldDecorator('country' + e._key, {
                        initialValue: e.country,
                        rules: [
                          {
                            required: true,
                            message: 'country is required',
                          },
                        ],
                      })(
                        <CountrySelect
                          onChange={handleChange.bind(this, 'address', e._key, 'country')}
                          value={e.country}
                        />
                      )}
                    </FormItem>
                  </Col>
                </FormItem>
                <FormItem label="Label" {...formItemLayout}>
                  <Col span={24}>
                    <FormItem {...formItemLayout}>
                      {getFieldDecorator('label' + e._key, {
                        initialValue: e.label,
                        rules: [
                          {
                            required: true,
                            message: 'Label is required',
                          },
                        ],
                      })(
                        <Input
                          placeholder="Label"
                          onChange={handleChange.bind(this, 'address', e._key, 'label')}
                          value={e.label}
                        />
                      )}
                    </FormItem>
                  </Col>
                </FormItem>
              </Row>
            </Fragment>
          )
        })}
    </Card>
  )
}

AddressList.propTypes = {}
AddressList.defaultProps = {}

export default AddressList
